import { useMutation, useQueryClient } from '@tanstack/react-query';
import { companyService } from '../services/company.service';
import type {
  CompanySettingsReturn,
  NotificationParams,
  RefereeParams,
  SecurityParams,
} from './companySettings.types';

export function useCompanySettings(): CompanySettingsReturn {
  const queryClient = useQueryClient();
  const onDone = (_: unknown, { id }: { id: string }): void => {
    void queryClient.invalidateQueries({ queryKey: ['company', id] });
  };
  const security = useMutation({
    mutationFn: ({ id, settings }: SecurityParams) =>
      companyService.updateSecuritySettings(id, settings),
    onSuccess: onDone,
  });
  const notification = useMutation({
    mutationFn: ({ id, preferences }: NotificationParams) =>
      companyService.updateNotificationPreferences(id, preferences),
    onSuccess: onDone,
  });
  const referee = useMutation({
    mutationFn: ({ id, settings }: RefereeParams) =>
      companyService.updateRefereeSettings(id, settings),
    onSuccess: onDone,
  });

  return {
    updateSecuritySettings: security.mutate,
    updateNotificationPreferences: notification.mutate,
    updateRefereeSettings: referee.mutate,
    isSecurityLoading: security.isPending,
    isNotificationLoading: notification.isPending,
    isRefereeSettingsLoading: referee.isPending,
    isSecurityError: security.isError,
    isNotificationError: notification.isError,
    isRefereeSettingsError: referee.isError,
    isSecuritySuccess: security.isSuccess,
    isNotificationSuccess: notification.isSuccess,
    isRefereeSettingsSuccess: referee.isSuccess,
    securityError: security.error,
    notificationError: notification.error,
    refereeSettingsError: referee.error,
  };
}
